import { call, put, select } from 'redux-saga/effects';

import { getAggregatesItaly } from '@api/aggregates';
import { intl } from '@helpers/intl';
import { aggregatesSummaryModelItaly } from '@models/Filing/aggregatesSummaryItaly';
import {
  requestAggregatesFailure,
  requestAggregatesSuccess,
} from '@store/filing/aggregates/aggregates.reducer';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';

import { updateResponse } from './helpers/updateResponse';

export const requestItalianAggregatesSaga = function* ({ payload }) {
  try {
    const { countryIso, id: filingPeriodId } = yield select(selectedFilingPeriodSelector);

    const response = yield call(getAggregatesItaly, payload);
    const updatedResponse = yield call(updateResponse, response);

    const result = yield call(
      aggregatesSummaryModelItaly,
      updatedResponse,
      countryIso,
      filingPeriodId
    );

    yield put(requestAggregatesSuccess(result));
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put(requestAggregatesFailure({ errorMessage: message }));
  }
};
